import { render, staticRenderFns } from "./CostInfo.vue?vue&type=template&id=c7034760"
import script from "./CostInfo.vue?vue&type=script&lang=js"
export * from "./CostInfo.vue?vue&type=script&lang=js"
import style0 from "./CostInfo.vue?vue&type=style&index=0&id=c7034760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports